import { BrowserRouter, Outlet, Route, Routes } from "react-router-dom";
import "./App.css";
import MaxLayout from "./MaxLayOut/MaxLayout";
import Performances from "./pages/performances/Performances";
import Login from "./pages/auth/Login";
import GlobalRankings from "./pages/global-rankings/GlobalRankings";
import MyProfile from "./pages/MyProfile";
import MainHome from "./pages/MainHome";
import Scores from "./pages/performances/scores/Scores";
import Progression from "./pages/performances/progression/Progression";
import Milestones from "./pages/performances/milestones/Milestones";
import PrivateRoute from "./components/PrivateRoute";

function App() {
  return (
    <BrowserRouter basename={process.env.REACT_APP_HOME_PAGE}>
      <Routes>
        <Route element={<PrivateRoute />}>
          <Route element={<MaxLayout />}>
            <Route path="/" element={<MainHome />} />
            <Route path="/performance" element={<Performances />} />
            <Route path="/global-ranking" element={<GlobalRankings />} />
            <Route path="/my-profile" element={<MyProfile />} />
            <Route path="/performance/score" element={<Scores />} />
            <Route path="/performance/progression" element={<Progression />} />
            <Route path="/performance/milestone" element={<Milestones />} />
          </Route>
        </Route>
        <Route path="/login" element={<Login />} />
      </Routes>
    </BrowserRouter>
  );
}
export default App;
